import config from "config"
import {
  ON_TOKEN, ON_LOGIN, PLAY_DONE, ON_PLAY_RESPONSE, SET_BET, UPDATE_STATS, RESET_REALITYCHECK,
  SET_SAVEDSETTINGS, DISPLAY_FREEROUND, CURRENCY_CHANGED, SET_NOFULLSCREEN, READY_FOR_PLAY_DONE,
  LOCALE_LOADED, FORCE_NEW_BALANCE, SET_RESTORESTATE, UPDATE_FREEROUND_TOTAL
} from '../constants'
import createReducer from '../createReducer'
import getInitialSessionState from '../initialStates/session'

/**
 * Function to update the current session stats.
 * @param {object} session - The current session object.
 * @param {object} stats - The new stats received.
 */
const updateStats = (session, stats) => {
  if (!stats)
    return

  session.currency = stats.currency
  session.balance = stats.b
  session.realityCheck = stats.realityCheck

  session.freeRoundStats = stats.freespins

  const freeRounds = (stats.freespins && stats.freespins.spins) ||
    (session.restoreState && session.restoreState.freeRounds &&
      session.restoreState.freeRounds.visibleFreeRoundSpins)
  session.freeRoundSpins = freeRounds || 0
}

/**
 * Reducer that handles session variables.
 * @param {object} state - The current session state.
 * @param {object} action - Object containing event information.
 * @returns {*}
 */
export default function sessionReducer(state = getInitialSessionState(), action) {
  switch (action.type) {
    case ON_TOKEN: {
      const { response = {} } = action.response
      const session = {
        userid: response.userid,
        remoteusername: response.remoteusername,
        token: response.token,
        replayToken: response.replaytoken
      }

      return createReducer(state, session)
    }
    case ON_LOGIN: {
      const { response } = action
      const session = {}
      const { stats, refresh } = response
      let deduct = 0
      let restoring = false

      if (response.limits) {
        Object.keys(response.limits).forEach(key => {
          session[key] = response.limits[key]
        })

        if (session.maxFeaturePurchasePrice === 0) {
          //UGLY AF! Will do for now though...
          config.disableBuyFeature = true
        }
      }

      session.sid = response.sid
      session.country = response.country

      if (response.savedSettings) {
        session.savedSettings = response.savedSettings
      }

      if (refresh) {
        if (refresh.l) {
          session.betAmount = refresh.l * refresh.la
          session.betLines = refresh.l
        } else {
          session.betAmount = refresh.correspondingBa || refresh.mainGameBa || refresh.ba
        }
        if (refresh.restoreState) {
          session.restoreState = refresh.restoreState.charAt(0) === '{' ?
            JSON.parse(refresh.restoreState) : refresh.restoreState

          if (Object.keys(session.restoreState).length > 0) {
            restoring = true
            session.visibleFreeRoundWin = session.restoreState.visibleFreeRoundWin !== undefined ?
              session.restoreState.visibleFreeRoundWin : 0

            if (refresh.win) {
              deduct = refresh.win
            }

            if (session.restoreState.hasOwnProperty('spin') || !response.refresh.ended) {
              session.betAmount = response.refresh.ba
            }
          }
        }
      }

      if (stats) {
        updateStats(session, stats)

        session.freeRoundSpins = stats.freespins ? stats.freespins.spins :
          (session.restoreState ? session.restoreState.spins : 0)

        if (stats.freespins) {
          const freespinsPlayed = stats.freespins.spinsPlayed > 0

          session.visibleFreeRoundWin = freespinsPlayed ? stats.freespins.win - deduct : 0
          if (restoring && stats.freespins.spinsended) {
            deduct = stats.freespins.win
          } else if (freespinsPlayed) {
            deduct = 0
          }
        }
        session.visibleBalance = stats.b - deduct
      }

      return createReducer(state, session)
    }
    case LOCALE_LOADED: {
      const { locale } = action
      return createReducer(state, { locale, loadedLocale: locale })
    }
    case ON_PLAY_RESPONSE: {
      const { response = {} } = action
      const session = {}
      if (!response)
        return createReducer(state, session)

      const { stats, win = 0 } = response

      if (stats) {
        updateStats(session, stats)

        if (stats.freespins && stats.freespins.spinsPlayed > 0 && !stats.freespins.perSpinPayouts) {
          if (stats.freespins.spins > 0)
            session.visibleBalance = stats.b
          else
            session.visibleBalance = stats.b - stats.freespins.win
        } else
          session.visibleBalance = (stats.b - win)
      }

      return createReducer(state, session)
    }
    case SET_BET: {
      const { payload = {} } = action

      return createReducer(state, payload)
    }
    case SET_NOFULLSCREEN: {
      const { noFullscreen } = action
      return createReducer(state, { noFullscreen })
    }
    case UPDATE_STATS: {
      const { stats } = action
      const session = {}

      if (stats)
        updateStats(session, stats)

      return createReducer(state, session)
    }
    case RESET_REALITYCHECK: {
      const { session } = state
      const newSession = { ...session }

      newSession.realityCheck = {}

      return createReducer(state, newSession)
    }
    case SET_SAVEDSETTINGS: {
      const { session } = state
      const newSession = { ...session }

      newSession.savedSettings = action.savedSettings

      return createReducer(state, newSession)
    }
    case UPDATE_FREEROUND_TOTAL: {
      const { win } = action
      return createReducer(state, { visibleFreeRoundWin: win })
    }
    case DISPLAY_FREEROUND: {
      const { display } = action
      const newState = state
      if (!display && state.restoreState) {
        delete newState.restoreState.freeRounds
      }
      return createReducer(state, newState)
    }
    case CURRENCY_CHANGED: {
      const { currencySign } = action
      return createReducer(state, { currencySign })
    }
    case READY_FOR_PLAY_DONE: {
      return createReducer(state, { restoreState: {}, visibleBalance: state.balance })
    }
    case FORCE_NEW_BALANCE: {
      const { balance, force } = action
      const session = { balance }
      if (force) {
        session.visibleBalance = balance
      }
      return createReducer(state, session)
    }
    case SET_RESTORESTATE: {
      return createReducer(state, { restoreState: null })
    }
    default:
      return state
  }
}
